import { render, staticRenderFns } from "./UserTabClass.vue?vue&type=template&id=601fe9ef&scoped=true&"
import script from "./UserTabClass.vue?vue&type=script&lang=js&"
export * from "./UserTabClass.vue?vue&type=script&lang=js&"
import style0 from "./UserTabClass.vue?vue&type=style&index=0&id=601fe9ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601fe9ef",
  null
  
)

export default component.exports